import { render, staticRenderFns } from "./FormModalEdit.vue?vue&type=template&id=bff8c3e0&scoped=true&"
import script from "./FormModalEdit.vue?vue&type=script&lang=js&"
export * from "./FormModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8c3e0",
  null
  
)

export default component.exports